<template>
 <div class="container" v-if="isShow">
      <div class="mask"></div>
      <div class="box">
           <p class="tip1">关注该退货页面</p>
           <p class="tip2">关注退货单后可在“我的关注”中</p>
           <p class="tip3">查询此退货单</p>
           <div class="btn">
                <span class="left" @click="sell">取消</span>
                <span class="right" @click="confirm">确定</span>
           </div>
      </div>
 </div>
</template>
<script>
    export default {
        data () {
            return {
                isShow: false,
                isFlag: true
            }
        },
        created () {

        },
        methods: {
            showBox () {
                this.isShow = true;
            },
            confirm () { // 关注
                this.isShow = false;
                if (this.isFlag) {
                    this.$emit('getAttention');
                    this.isFlag = false;
                }
            },
            sell () {
                this.isShow = false;
            }
        }
    }
</script>
<style lang="less" scoped>
.container{
    width:100%;
    height:100%;
    // position: absolute;
    // left:0;
    // top:0;
    // z-index: 20;
    // background-color: pink;
    .mask{
        width:100%;
        height:100%;
        position: fixed;
        left:0;
        top:0;
        z-index: 20;
        background: rgba(0,0,0,.5);
    }
    .box{
        position: fixed;
        width:260px;
        // height:200px;
        // padding:30px 0 30px 0;
        background: #fff;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        z-index: 30;
        text-align: center;
        border-radius: 3px;
        .tip1{

            font-size:18px;
            color:#000;
            margin-top:32px;
        }
        .tip2{

            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:12px;
        }
        .tip3{
            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:8px;
        }
        .btn{
            width:100%;
            padding:0 15px;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            flex-direction: row;
            margin-top:24px;
            margin-bottom: 16px;
            .left{
                width:110px;
                height:40px;
                border:1px solid #CCCCCC;
                text-align: center;
                line-height: 40px;
                font-size:15px;
                border-radius: 2px;
                color:#999999;
            }
            .right{
                width:110px;
                height:40px;
                background: @base-color;
                border:1px solid @base-color;
                border-radius: 2px;
                color:#fff;
                text-align: center;
                line-height: 40px;
                font-size:15px;
            }
        }
    }
}
</style>
